import styled from 'styled-components';

export const Root = styled.div`
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid ${({ theme }) => theme.colors.grey3};
`;

export const Title = styled.div`
  font-weight: bold;
`;
